import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {MediosComponent} from '../medios.component'
//Services
import {TransmediaService} from 'src/app/core/services/parameters/transmedia.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearMedioModal implements OnInit {

  newMedioForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<MediosComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private transmediaService: TransmediaService
  ) {
  }

  ngOnInit(): void {
    this.newMedioForm = this.fb.group({
      medio: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newMedioForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newMedioForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.medio
      }
      this.transmediaService.createTransmedia(data).subscribe(_res => {
        this.alert.setNotice('Medio creado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el medio', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
